export default "__VITE_PUBLIC_ASSET__21f92b05__"